import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useOnce } from '@root/src/web/lib/useOnce';
import { pickMessage, } from '@root/src/web/lib/messagePicker';
import { ReaderRevenueEpic, canShow as canShowReaderRevenueEpic, } from './ReaderRevenueEpic';
import { MaybeBrazeEpic, canShow as canShowBrazeEpic } from './BrazeEpic';
const buildReaderRevenueEpicConfig = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, idApiUrl, stage, asyncArticleCount, }) => {
    return {
        candidate: {
            id: 'reader-revenue-banner',
            canShow: () => canShowReaderRevenueEpic({
                isSignedIn,
                countryCode,
                contentType,
                sectionName,
                shouldHideReaderRevenue,
                isMinuteArticle,
                isPaidContent,
                tags,
                contributionsServiceUrl,
                idApiUrl,
                stage,
                asyncArticleCount,
            }),
            show: (meta) => () => {
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                return _jsx(ReaderRevenueEpic, Object.assign({}, meta), void 0);
            },
        },
        timeoutMillis: null,
    };
};
const buildBrazeEpicConfig = (brazeMessages, countryCode, idApiUrl, brazeArticleContext) => {
    return {
        candidate: {
            id: 'braze-epic',
            canShow: () => canShowBrazeEpic(brazeMessages, brazeArticleContext),
            show: (meta) => () => (_jsx(MaybeBrazeEpic, { meta: meta, countryCode: countryCode, idApiUrl: idApiUrl }, void 0)),
        },
        timeoutMillis: 2000,
    };
};
export const SlotBodyEnd = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, brazeMessages, idApiUrl, stage, asyncArticleCount, }) => {
    const [SelectedEpic, setSelectedEpic] = useState(null);
    useOnce(() => {
        const readerRevenueEpic = buildReaderRevenueEpicConfig({
            isSignedIn,
            countryCode,
            contentType,
            sectionName,
            shouldHideReaderRevenue,
            isMinuteArticle,
            isPaidContent,
            tags,
            contributionsServiceUrl,
            idApiUrl,
            stage,
            asyncArticleCount: asyncArticleCount,
        });
        const brazeArticleContext = {
            section: sectionName
        };
        const brazeEpic = buildBrazeEpicConfig(brazeMessages, countryCode, idApiUrl, brazeArticleContext);
        const epicConfig = {
            candidates: [brazeEpic, readerRevenueEpic],
            name: 'slotBodyEnd',
        };
        pickMessage(epicConfig)
            .then((PickedEpic) => setSelectedEpic(PickedEpic))
            .catch((e) => console.error(`SlotBodyEnd pickMessage - error: ${e}`));
    }, [isSignedIn, countryCode, brazeMessages, asyncArticleCount]);
    if (SelectedEpic) {
        return _jsx(SelectedEpic, {}, void 0);
    }
    return null;
};
